import Popup from "./popup";
import Snackbar from "./snackbar";

class PopupScanner extends Popup {
    constructor() {
        super("[id$=popup-overlay-scanner]", "[id$=popup-scanner]");
        this.handleCheckinout = this.handleCheckinout.bind(this);
        this.snackbar = new Snackbar();

        this.snackbarShow = this.snackbarShow.bind(this);
        this.toggleLoader = this.toggleLoader.bind(this);

        document.addEventListener("updatePopupContent", (event) => {
            this.overlay.innerHTML = event.content;
            this.popup = this.overlay.querySelector("[id$=popup-scanner]");

            this.action = document.querySelector(".check-inout-action");

            if (this.action) {
                this.action.addEventListener("click", this.handleCheckinout);
            }

            this.bindCancelButton();
        });

        document.addEventListener("updateIssuePopup", () => {
            document.querySelector("#scan-text").innerHTML = document.querySelector("#scan-text").dataset.errorMessage;

            document.dispatchEvent(new Event("bindScannerKeydown"));

            this.toggleLoader();
        });

        document.addEventListener("toggleLoader", () => this.toggleLoader());

        document.addEventListener("togglePopupScanner", () => this.toggleClasses());
    }

    handleCheckinout(event) {
        event.preventDefault();
        const url = event.target.href;
        let message = "";
        fetch(url, {
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
        }).then(response => response.json()).then((json) => {
            json.messages.forEach((text) => {
                message += `${text}\r\n`;
            });
            this.snackbarShow(message);
            this.cancel();
        });
    }

    snackbarShow(message) {
        this.snackbar.show(message);
    }

    bindCancelButton() {
        super.bindCancelButton("#popup-scanner");
    }

    toggleLoader() {
        const loader = document.getElementById("loader");
        const scannerReady = document.getElementById("scanner-ready");

        loader.classList.toggle("d-n");
        loader.classList.toggle("d-f");

        scannerReady.classList.toggle("d-n");
        scannerReady.classList.toggle("d-f");
    }

    cancel() {
        super.cancel();
        document.dispatchEvent(new Event("unbindScannerKeydown"));
    }
}

export default PopupScanner;
